import { render, staticRenderFns } from "./FixFavourites.vue?vue&type=template&id=5abe23ab&scoped=true"
import script from "./FixFavourites.vue?vue&type=script&lang=js"
export * from "./FixFavourites.vue?vue&type=script&lang=js"
import style0 from "./FixFavourites.vue?vue&type=style&index=0&id=5abe23ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe23ab",
  null
  
)

export default component.exports